import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarOff, X, Phone, ArrowRight } from 'lucide-react';
import { api } from '../context/AuthContext';

const TEL = '+49 (0) 228 30 40 640';
const fmt = (iso) => `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}`;
let cache = null;

const useSchliesszeit = () => {
  const [s, setS] = useState(cache);
  const [zu, setZu] = useState(false);
  useEffect(() => {
    if (!cache) api.get('/public/schliesszeit').then((r) => { cache = r.data; setS(r.data); }).catch(() => {});
  }, []);
  useEffect(() => { if (s?.aktiv) setZu(localStorage.getItem(`schliesszeit-zu-${s.id}`) === '1'); }, [s]);
  const schliessen = () => { localStorage.setItem(`schliesszeit-zu-${s.id}`, '1'); setZu(true); };
  return { s: s?.aktiv && !zu ? s : null, schliessen };
};

const text = (s) => s.hinweis || `Unsere Kanzlei ist vom ${fmt(s.von)} bis ${fmt(s.bis)} geschlossen${s.bezeichnung ? ` (${s.bezeichnung})` : ''}.`;

// Schmaler Balken unter der Kopfzeile (öffentliche Seiten, Gäste und Mandanten).
export const SchliesszeitBalken = () => {
  const { s, schliessen } = useSchliesszeit();
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(() => { document.body.style.paddingTop = `${el.offsetHeight}px`; });
    ro.observe(el);
    return () => { ro.disconnect(); document.body.style.paddingTop = ''; };
  }, [s]);
  if (!s) return null;
  return (
    <div ref={ref} className="bg-[#0B1724] text-white text-xs sm:text-sm border-t border-[#b8893d]/50" data-testid="schliesszeit-balken">
      <div className="max-w-7xl mx-auto px-4 lg:px-10 py-2 flex items-center gap-3">
        <CalendarOff className="w-4 h-4 text-[#e0b56a] shrink-0" />
        <p className="flex-1 min-w-0 leading-snug">{text(s)} <span className="text-white/70">In dringenden Fällen:</span>{' '}
          <Link to="/notfallkontakt" className="text-[#e0b56a] underline underline-offset-2" data-testid="schliesszeit-notfall-link">Notfallkontakt</Link>
          <span className="hidden sm:inline text-white/70"> · Tel. {TEL}</span></p>
        <button type="button" onClick={schliessen} className="h-7 w-7 inline-flex items-center justify-center rounded-md text-white/70 hover:text-white shrink-0" aria-label="Hinweis schließen" data-testid="schliesszeit-balken-schliessen"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};

// Karte oben im Mandantenportal.
export const SchliesszeitKarte = () => {
  const { s, schliessen } = useSchliesszeit();
  if (!s) return null;
  return (
    <div className="relative bg-white border border-[#b8893d]/50 rounded-2xl p-5 shadow-sm" data-testid="schliesszeit-karte">
      <button type="button" onClick={schliessen} className="absolute top-3 right-3 h-7 w-7 inline-flex items-center justify-center rounded-md text-gray-400 hover:text-gray-600" aria-label="Hinweis schließen" data-testid="schliesszeit-karte-schliessen"><X className="w-4 h-4" /></button>
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#b8893d] mb-2"><CalendarOff className="w-4 h-4" /> {s.laeuft ? 'Kanzlei derzeit geschlossen' : 'Schließzeit der Kanzlei'}</div>
      <p className="text-[#1B3A5C] text-sm pr-6">{text(s)}</p>
      <p className="text-xs text-[#34536b] mt-1">Nachrichten und Unterlagen können Sie weiterhin über das Portal senden; wir bearbeiten sie nach unserer Rückkehr.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Link to="/notfallkontakt" className="inline-flex items-center gap-1.5 h-9 px-3 rounded-[10px] bg-[#1B3A5C] text-white text-xs" data-testid="schliesszeit-karte-notfall">Notfallkontakt <ArrowRight className="w-3.5 h-3.5" /></Link>
        <a href="tel:+492283040640" className="inline-flex items-center gap-1.5 h-9 px-3 rounded-[10px] border border-gray-300 text-[#1B3A5C] text-xs" data-testid="schliesszeit-karte-tel"><Phone className="w-3.5 h-3.5" /> {TEL}</a>
      </div>
    </div>
  );
};
